import React, { Fragment, useContext } from "react";
import { PropTypes } from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { AppBar, Grid } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

import Toolbar from "@material-ui/core/Toolbar";
import logo from "../../assets/images/logo_transp.png";
import { withRouter } from "react-router-dom";
import PulseLoader from "react-spinners/PulseLoader";
import { colors } from "../../assets/theme";
import GlobalContext from "../../state/GlobalContext";

const styles = theme => ({
  main: {
    marginTop: 64,
    width: "100%"
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1
  },
  logo: {
    maxWidth: 200,
    maxHeight: 60,
    "&:hover": {
      cursor: "pointer"
    }
  }
});

const loadingPulse = (
  <Grid container justify="center" alignItems="center" style={{ height: 200 }}>
    <PulseLoader color={colors.LOADING} />
  </Grid>
);

const NavBar = ({ classes, history }) => {
  return (
    <nav>
      <AppBar color="primary" position="fixed" className={classes.appBar}>
        <Toolbar>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <img
                alt="ooPark-community"
                className={classes.logo}
                src={logo}
                onClick={() => history.push("/")}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </nav>
  );
};

const PublicRoute = ({ classes, component, exact, path, history }) => {
  const { session } = useContext(GlobalContext);
  const { user, loading } = session.state;
  return (
    <Route
      exact={exact}
      path={path}
      render={props => (
        <Fragment>
          <NavBar classes={classes} history={history} />
          <main className={classes.main}>
            {loading ? loadingPulse : React.createElement(component)}
          </main>
        </Fragment>
      )}
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.func.isRequired,
  exact: PropTypes.bool,
  path: PropTypes.string,
  content: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string
};

export default withRouter(withStyles(styles)(PublicRoute));
